import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const REACT_APP_APIGEE = process.env.REACT_APP_APIGEE;

const landingPageService = {
    fetchPKICertificatesToken: async () => {
        const localToken = localStorage.getItem("okta-token-storage");
        if (!localToken) return null;

        try {
            const response = await pkiAxios.post(
                `https://mycert-ite-pepsico.appvx.com/avxapi/acctmgmt-get-service-token?gwsource=web`,
                {
                    grant_type: "client_credentials",
                },
                {
                    headers: {
                        Authorization: `Basic ODg5ODVlMjYtYjliMy00ZjkwLWFkYmQtMDZkNTA4NmFmNzg3OiUzS0s4eldKJDEwMGhPUTZIWVloZlNQJGFuQ2hpMUdl`, // ✅ Authorization header
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching PKI certificates token:", error);
            return {
                "response": "eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiJ9.eyJzdWIiOiJhcGlfdXNlcl9wa2llbmciLCJhdWQiOiJhdngiLCJjbGllbnRJZCI6Ijg4OTg1ZTI2LWI5YjMtNGY5MC1hZGJkLTA2ZDUwODZhZjc4NyIsImlzcyI6ImF2eCIsImV4cCI6MTc1MzIwNzQ4MiwiaWF0IjoxNzUzMTk2NjgyLCJncmFudCB0eXBlIjoiY2xpZW50X2NyZWRlbnRpYWxzIn0.AAUxBYEUfVCjEGxpEYyYOmF4Wn_xWXueUMBkeytkwxwodDM4fsioRw0zJ3eN1xIwbbzQ8QFFGet0HsIlgu5Xyba4AfnIO7SwLSiOHrz1WReVWyXDFfzv2yrqklUxys_P_DmQWsLmOHYR1VqGJolqapcQ8acCK76AIWWly-n-Dkf9Ao88",
                "message": null,
                "appStatusCode": null,
                "tags": {},
                "headers": null
            };
        }
    },

    fetchPKICertificatesCount: async (gpid) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}pki/expiringCertificates`, {  "gpid": gpid  });
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
        // try {
        //     const response = await pkiAxios.post(
        //         `https://mycert-ite-pepsico.appvx.com/avxapi/execute-hook?gwsource=external`,
        //         payload,
        //         {
        //             headers: {
        //                 token: token,
        //                 "Content-Type": "application/json",
        //             },
        //         });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching PKI certificates token:", error);
        //     return null;
        // }
    },

    fetchRequestCount: async () => {
        try {
            const response = await axios.post(`${REACT_APP_APIGEE}user/requestCount`);
            return response.data;
        } catch (error) {
            console.error("Error fetching request count:", error);
            throw error;
        }
    },
};

export default landingPageService;
